{
  "accessControl.delete.confirmation": "<1>{{ value }}</1> has been deleted from Access Control.",
  "accessControl": "Access control",
  "memberFee.add": "Add fee",
  "addFromResourceBase": "Add from resource base",
  "addNew": "Add new",
  "addToBoard": "Add to board",
  "addUser": "Add user",
  "clusterMemberAdvisor.title": "Advisors",
  "focusArea.details.subtitle": "All projects and activities connected to the focus area are listed below.",
  "mainGoal.details.subtitle": "All projects and activities connected to the main goal are listed below.",
  "projectCategory.details.description.1": "All projects and activities connected to the project category are listed below.",
  "memberFee.amount": "Amount (kr)",
  "eMailInviteWillBeSent": "An email with an invite will be sent to this user.",
  "projectCategory.delete.confirm": "Are you sure you want to delete {{ name }}?",
  "accessControl.delete.modal.title": "Are you sure you want to delete these users?",
  "deleteInterestAreaMessage": "Are you sure you want to delete this interest area?",
  "memberFee.delete.title": "Are you sure you want to delete this memberfee?",
  "timeRate.delete.confirmation": "Are you sure you want to delete this time rate?",
  "timeRate.description": "At the top shows the amount for the default time rate. This time rate will account for all contacts in the cluster - unless you define a custom time rate for the contact. (Demonstrated later in the user manual)",
  "clusterBoardMember.title": "Board members",
  "changeRole": "Change role",
  "changeRoleFor": "Change role for",
  "chooseRole": "Choose role",
  "coreData": "Core data",
  "addUser.error": "Could not add this user.",
  "interestArea.error.edit": "Could not change insterst area. Please try again.",
  "error.mainContact.update": "Could not change main contact. Please try again.",
  "error.interestArea.create": "Could not create new interest area. Please try again.",
  "timeRate.create.error": "Could not create time rate. Please try again.",
  "error.interestArea.delete": "Could not delete interest area. Please try again.",
  "interestArea.error.delete": "Could not delete interest area. Please try again.",
  "projectCategory.error.delete": "Could not delete project category. Please try again.",
  "accessControl.delete.error": "Could not delete the users, please try again.",
  "timeRate.delete.error": "Could not delete time rate. Please try again.",
  "interestArea.error.save": "Could not save interest area. Please try again.",
  "error.interestArea.update": "Could not update interest area. Please try again.",
  "projectCategory.error.edit": "Could not update project category. Check if the name is already in use, and try again.",
  "timeRate.update.error": "Could not update time rate. Please try again.",
  "projectCategory.delete": "Delete project category",
  "portalInvitation.modal.description": "Do you want to send a portal invitation to these contacts?",
  "editDefaultTimeRate": "Edit default time rate",
  "editInterestAreas": "Edit interest area",
  "memberFee.edit": "Edit member fee",
  "projectCategory.edit": "Edit project category",
  "editTimeRate": "Edit time rate",
  "employees": "Employees",
  "external": "External",
  "focusArea.notFound": "Focus area not found",
  "memberFee.delete.description": "If you delete this memberfee, all members connected to this fee will loose their fee.",
  "timeRate.delete.description": "If you delete this time rate, all contacts with this rate will be put on default time rate.",
  "interestAreas": "Interest areas",
  "clusterManagement.title": "Management",
  "memberFee": "Membership fee",
  "mission": "Mission",
  "memberFee.name": "Name of fee",
  "memberFee.new": "New member fee",
  "memberFee.delete.noMembers": "No members is connected to this memberfee.",
  "otherTimeRates": "Other time rates",
  "clusterManagement.description": "Please add all contact persons who make up the management.",
  "portalInvitation.success": "Portal invitations sent!",
  "project": "project",
  "projectCategories": "Project categories",
  "projectCategory.details.title": "Project categories projects and activities",
  "projectCategory": "Project category",
  "projectCategory.details.description.2": "Project category cannot be deleted if there are projects using it.",
  "projectCategory.notFound": "Project category not found",
  "project_plural": "projects",
  "removeFromManagement": "Remove from management",
  "searchByNameEmailOrRole": "Search for name, email or role",
  "selectRole": "Select role",
  "sendInvite": "Send invite",
  "sendPortalInvitation": "Send portal invitation",
  "portalInvitation.pending": "Sending portal invitations...",
  "memberFee.description": "Set up a number of membership dues that suit the way you organize the members. You can set a membership fee on each member or set a custom amount.",
  "focusArea.details.title": "The focus area's projects and activities",
  "mainGoal.details.title": "The main goal's projects and activities",
  "memberFee.delete.members": "There are {{ count }} members connected to this fee.",
  "fieldRequired": "This field is required",
  "accessControl.delete.text": "This will delete <1>{{ value }}</1> from Access Control. The concerned party will lose access to Flerbedriftsportalen. You cannot undo this action.",
  "timeRates": "Time rates",
  "memberFee.tips": "Tip: Add amounts to the name of this contingent to get a quick overview of names and amounts when linking members to the contingent",
  "vision": "Vision",
  "visionMission.title": "Vision and mission",
  "yourProfile.title": "Your profile",
  "accessControl.invite.error": "Could not invite users. Please try again.",
  "accessControl.createUser.title.selectMethod": "Choose how you want to add a new user",
  "accessControl.createUser.title.searchExistingContact": "Retrieve information from a contact",
  "accessControl.createUser.title.createNewUser": "Add new user",
  "accessControl.createUser.confirmation.text": "<1>{{ name }}</1> has been added.",
  "accessControl.createUser.create.error.message": "Could not create user. Please try again.",
  "accessControl.createUser.invite.error.message": "Cloud not invite user. Please try agian.",
  "accessControl.inviteUser.confirmation.text": "Invitation emails have been sent out to these users.",
  "accessControl.deleteUsers.text": "These users have been deleted from Access Control.",
  "accessControl.delete.error.modal.title": "Sorry, we cannot delete these users",
  "accessControl.delete.error.modal.description": "Unfortunately, these users have not been deleted from Access Control",
  "accessControl.delete.error.modal.supportText": "Feel free to check if they have already been deleted from Access Control, or contact us at <1>{{ email }}</1>",
  "accessControl.create.cluster.radio.label": "Do you have a registered contact you wish to grant access to Flerbedriftsportalen?",
  "accessControl.create.cluster.radio.value.existing": "Yes, I want to retrieve the information from a contact in the Resource Base",
  "accessControl.create.cluster.radio.value.new": "No, I want to add a new user",
  "accessControl.create.cluster.radio.error": "You must choose at least one way to add a new user",
  "accessControl.selectAccessType": "Choose access type",
  "accessControl.roles.internal.writeAccess": "Employee - write access",
  "accessControl.roles.external.readAccess": "External - read-only access",
  "accessControl.roles.select.helpText": "All employees get write access, but only the administrator can add new users. External users get read-only access and cannot make changes to the portal.",
  "accessControl.roles.select.label": "Access type",
  "accessControl.edit.modal.title.default": "Edit user information",
  "accessControl.edit.modal.title.error": "Sorry, we could not modify this user",
  "accessControl.edit.modal.confirmation.text": "The information for <1>{{ name }}</1> has been updated.",
  "accessControl.edit.modal.error.supportText": "Feel free to reload the page and try to modify the contact again, or contact us at <1>{{ email }}</1>",
  "accessControl.edit.modal.error.text": "An error occurred while updating <1>{{ name }}</1>. Please try again.",
  "emailSettings": "Email alerts",
  "emailSettings.updateOk": "E-mail settings updated",
  "emailSettings.updateFailed": "Could not update e-mail settings.",
  "emailSettings.frequency": "Frequency",
  "emailsettings.activity": "Activity",
  "emailSettings.opportunities": "New Opportunities"
}
